// Byte <-> base64 helpers for JSON transports (typed arrays don't survive
// JSON-over-WS). Implemented on btoa/atob, which exist both in browsers and
// in Node >= 16, so the helpers work wherever this isomorphic lib runs.

// btoa takes a binary string; build it in chunks so a large buffer doesn't
// blow the argument limit of String.fromCharCode.apply.
const CHUNK_SIZE = 0x8000;

export function bytesToBase64(bytes: Uint8Array): string {
  let binary = '';

  for (let i = 0; i < bytes.length; i += CHUNK_SIZE) {
    binary += String.fromCharCode(...bytes.subarray(i, i + CHUNK_SIZE));
  }

  return btoa(binary);
}

export function base64ToBytes(base64: string): Uint8Array {
  return Uint8Array.from(atob(base64), (c) => c.charCodeAt(0));
}
